import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        outline: "text-foreground",
        "main-padel": "bg-group-main-padel text-group-main-padel-foreground",
        "beginners": "bg-group-beginners text-group-beginners-foreground",
        "intermediate": "bg-group-intermediate text-group-intermediate-foreground",
        "intermediate-plus": "bg-group-intermediate-plus text-group-intermediate-plus-foreground",
        "advanced": "bg-group-advanced text-group-advanced-foreground",
        "admins": "bg-group-admins text-group-admins-foreground",
        "tournament": "bg-group-tournament text-group-tournament-foreground",
        "admin": "bg-admin-role text-admin-role-foreground",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge,  }
